module.exports = __webpack_public_path__ + "static/insurance-doc-1bf3bcaeac39c6660a5c98fe4e89b328.pdf";